export function validateEmail(email: string): boolean {
    const e = email.trim();

    // basic shape
    if (e.length < 3 || e.length > 254) return false;

    const at = e.indexOf("@");
    if (at <= 0 || at !== e.lastIndexOf("@")) return false;

    const local = e.slice(0, at);
    const domain = e.slice(at + 1);

    // local/domain length rules
    if (local.length === 0 || local.length > 64) return false;
    if (domain.length === 0 || domain.length > 253) return false;

    // no spaces
    if (/\s/.test(e)) return false;

    // domain must have at least one dot and no empty labels
    if (!domain.includes(".")) return false;
    if (domain.startsWith(".") || domain.endsWith(".")) return false;
    if (domain.includes("..")) return false;

    const labels = domain.split(".");
    if (labels.some(l => l.length === 0)) return false;

    // allowed chars in domain labels (letters/digits/hyphen), no leading/trailing hyphen
    for (const label of labels) {
        if (!/^[a-zA-Z0-9-]+$/.test(label)) return false;
        if (label.startsWith("-") || label.endsWith("-")) return false;
    }

    // local part: keep it permissive but disallow obvious bad patterns
    if (local.startsWith(".") || local.endsWith(".")) return false;
    if (local.includes("..")) return false;

    return true;
}
